export const BASE_URL = "https://administracionbiugb.ugb.edu.sv";

const createUrl = (base, path) => `${base}${path}`;

//  get properties by filters
const getProperties = ({ page, perPage }) => [
  createUrl(BASE_URL, `/api/properties/?page=${page}&per_page=${perPage}`),
];
const getByID = ({ id }) => [createUrl(BASE_URL, `/api/properties/${id}`)];
const getPropertyByName = ({
  page,
  perPage,
  term,
  zone,
  propertyType,
  businessActivity,
  suburb,
}) => [
  createUrl(
    BASE_URL,
    `/api/properties/?page=${page}&per_page=${perPage}&name__icontains=${term}&zone__in=${zone}&propertytype__in=${propertyType}&business_activity__in=${businessActivity}&suburb__in=${suburb}`
  ),
];

// get Latest Added
const getLatestAdded = () => [createUrl(BASE_URL, `/api/properties/latest_added/`)];

// get Most Visited
const getMostVisited = () => [createUrl(BASE_URL, `/api/properties/most_visited/`)];

// get Catalogs
const getBussinesActivities = () => [createUrl(BASE_URL, `/api/business-activities/`)];
const getPropertyTypes = () => [createUrl(BASE_URL, `/api/property-types/`)];
const getZones = () => [createUrl(BASE_URL, `/api/zones/`)];
const getSuburbs = () => [createUrl(BASE_URL, `/api/suburbs/`)];

export default {
  getProperties,
  getByID,
  getPropertyByName,
  getLatestAdded,
  getMostVisited,
  getBussinesActivities,
  getZones,
  getPropertyTypes,
  getSuburbs,
};
